export const images = [
  { id: 1, original: "/images/services/1/highlights/c1-hp1.jpg" },
  { id: 2, original: "/images/services/1/highlights/c1-hp2.jpg" },
  { id: 3, original: "/images/services/1/highlights/c1-hp3.jpg" },
  { id: 4, original: "/images/services/1/highlights/c1-hp4.jpg" },
  { id: 5, original: "/images/services/1/highlights/c1-hp5.jpg" },
];
